export const ACCESS_DENIED_ROLE_MESSAGE = "This information is not available for your role";
